import { useFullAsyncState } from '../../hooks';
import { paymentIntentRequiresCapture } from './paymentIntentRequiresCapture';

type UseKlarnaApprovedReturnType = {
  loading: boolean,
  approved: boolean | null,
};

export const useKlarnaApproved = (clientSecret: string): UseKlarnaApprovedReturnType => {
  const {
    data: isKlarnaApproved,
    loading: isLoadingPaymentIntent,
  } = useFullAsyncState(
    async () => {
      if (!clientSecret) return null;
      const result = await paymentIntentRequiresCapture(clientSecret);
      return result;
    },
    [clientSecret],
  );

  return {
    loading: isLoadingPaymentIntent,
    approved: isKlarnaApproved,
  };
};
